export class Contact {

  desc: string;
  type: string;
  value: string;

  constructor(json: any, accountType = '') {
    let show = accountType !== '' && accountType !== 'Basic';
    try {
      this.desc = json.desc || '';
      this.type = json.type || '';
      this.value = show ? json.value : 'blurred text';
    } catch (ex) {
      this.desc = '';
      this.type = '';
      this.value = show ? '' : 'blurred text';
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/models/contact.ts